import i18n from "i18next";

interface Translation {
    id: number;
    title: string;
    description: string;
    isoCode: string;
}

export const defaultTranslation: Translation = {
    id: 0,
    title: "_title",
    description: "_description",
    isoCode: "unknown",
};

export interface MenuCategoryTranslation extends Translation {}
export interface MenuItemTranslation extends Translation {}

export function getTranslation<T extends Translation>(
    translations: T[],
    fallback = "en",
    lang?: string
): T {
    const currentLang = lang ?? i18n.language;

    const matchingTranslation = translations.find(
        (translation) => translation.isoCode.toLowerCase() === currentLang.toLowerCase()
    );
    if (matchingTranslation) return matchingTranslation;

    const fallbackTranslation = translations.find(
        (translation) => translation.isoCode.toLowerCase() === fallback.toLowerCase()
    );
    if (fallbackTranslation) return fallbackTranslation;

    if (translations.length > 0) {
        console.warn(`No translation found for ${currentLang} or fallback (${fallback}). Using the first translation.`);
        return translations[0];
    }

    console.warn(`No translation found for ${currentLang} or fallback (${fallback}).`);
    return defaultTranslation as T;
}